import { render, staticRenderFns } from "./EmptyTablePlaceholder.vue?vue&type=template&id=4960a74e&"
import script from "./EmptyTablePlaceholder.vue?vue&type=script&lang=js&"
export * from "./EmptyTablePlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./EmptyTablePlaceholder.vue?vue&type=style&index=0&id=4960a74e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports